import { getCoreDataSecurityMonitoredObjectsSlice } from './get';
import { postCoreDataSecurityMonitoredObjectsSlice } from './post';

export const { requestGetCoreDataSecurityMonitoredObjects, resetGetCoreDataSecurityMonitoredObjects } =
	getCoreDataSecurityMonitoredObjectsSlice.asyncActionCreators;

export const { requestPostCoreDataSecurityMonitoredObjects, resetPostCoreDataSecurityMonitoredObjects } =
	postCoreDataSecurityMonitoredObjectsSlice.asyncActionCreators;
